import React from 'react';


function Universe() {
  return (
    
<div className="container mt-5 ">
      <div className="row text-center">
        <h1>The Zerodha Universe</h1>
        <p>Explore our suite of products designed to enhance your trading and investment experience.</p>

     <div className="col-4 p-3 mt-5">
          <img src="media/smallcaseLogo.png"  className="img-fluid" />
        </div>
     <div className="col-4 p-3 mt-5">
          <img src="media/streakLogo.png"  className="img-fluid" />
        </div>
     <div className="col-4 p-3 mt-5">
          <img src="media/sensibullLogo.svg"  className="img-fluid" />
        </div>
     <div className="col-4 p-3 mt-5">
          <img src="media/zerodhaFundhouse.png"  className="img-fluid" />
        </div>
     <div className="col-4 p-3 mt-5">
          <img src="media/goldenpiLogo.png"  className="img-fluid" />
        </div>
     <div className="col-4 p-3 mt-5">
          <img src="media/dittoLogo.png"  className="img-fluid" />
        </div>
        <button style={{width:"25%", margin: "0 auto"}} className='p-2 btn btn-primary fs-4 mb-5'  >SignUp Today!</button>
      </div>
    </div>
       

   
  );
}

export default Universe;